import { cn } from "#app/utils/misc.tsx";
import Container from "./container";

export function Text({
  as: Component = 'span',
  className,
  color = 'default',
  size = 'copy',
  width = 'default',
  children,
  ...props
}: {
  as?: React.ElementType;
  className?: string;
  children: React.ReactNode;
  [key: string]: any;
}) {
    const sizes: Record<string, string> = {
        lead: 'text-body-lg',
        copy: 'text-body-md',
        fine: 'text-body-sm subpixel-antialiased',
      };
    
      const widths: Record<string, string> = {
        default: 'max-w-prose',
        narrow: 'max-w-prose-narrow',
        wide: 'max-w-prose-wide',
      };
    
    const styles = cn(
        widths[width],
        sizes[size],
        className,
    );

  return (
    <Component {...props} className={styles}>
      {children}
    </Component>
  );
}

export function Heading({
  as: Component = 'h2',
  children,
  className = '',
  size = 'heading',
  width = 'default',
  ...props
}: {
  as?: React.ElementType;
  children: React.ReactNode;
  size?: 'display' | 'heading' | 'lead' | 'copy';
  width?: 'default' | 'narrow' | 'wide';
} & React.HTMLAttributes<HTMLHeadingElement>) {
    
    const widths = {
        default: 'max-w-2xl',
        narrow: 'max-',
        wide: 'max-w-prose-wide',
    };

    const styles = cn(
        widths[width],
        className,
    );
    return (
        <Component {...props} className={styles}>
        {children}
        </Component>
    );
}

export function PageHeader({
  children,
  className,
  heading,
  variant = 'default',
  ...props
}: {
  children?: React.ReactNode;
  className?: string;
  heading?: string;
  variant?: 'default' | 'servicesPage' | 'servicePage';
  [key: string]: any;
}) {
  const variants: Record<string, string> = {
    default: 'grid w-full gap-8 py-12 sm:py-16 justify-items-center',
    servicesPage: 'grid justify-items-center w-full gap-8 py-16 md:py-20 lg:py-24 lg:pb-32',
    servicePage: 'grid justify-items-center w-full gap-8 pt-16 md:pt-20 lg:pt-24 ',
  };

  const styles = cn(variants[variant], className);

  return (
    <Container {...props} className={styles}>
      {heading && (
        <Heading as="h1" className="inline-block">
          {heading}
        </Heading>
      )}
      {children}
    </Container>
  );
}